import { render, staticRenderFns } from "./b-loading-spinner2.vue?vue&type=template&id=44d4c155&scoped=true"
import script from "./b-loading-spinner2.vue?vue&type=script&lang=js"
export * from "./b-loading-spinner2.vue?vue&type=script&lang=js"
import style0 from "./b-loading-spinner2.vue?vue&type=style&index=0&id=44d4c155&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d4c155",
  null
  
)

export default component.exports